export const TEST_ROUTE = "test/route";
export const CONTACT_WEBINAR = "webinar/webinarDetails?contactwebinar="
export const WATCHED_WEBINAR = "webinar/webinarWatchedDuration"
